<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <div class="d-flex align-center mb-6">
        <v-icon color="primary" large class="mr-3">mdi-cog-outline</v-icon>
        <ModuleHeader class="mb-0">Configuración por departamento</ModuleHeader>
      </div>

      <v-row>
        <!-- Sidebar: Departments -->
        <v-col md="3" cols="12">
          <v-card outlined class="rounded-lg shadow-sm">
            <v-toolbar flat dense color="grey lighten-5">
              <v-toolbar-title class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
                <v-icon small class="mr-2">mdi-office-building</v-icon>
                Departamentos
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list dense nav class="pa-2">
              <v-list-item-group v-model="selectedOption" color="primary" mandatory>
                <v-list-item v-for="(dep, index) in dataDep" :key="index" @click="selectOption(index)"
                  class="rounded-md mb-1">
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-store-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ dep.id }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>

        <!-- Main Content: Settings -->
        <v-col md="9" cols="12">
          <div v-for="(dep, index) in dataDep" :key="index">
            <v-card v-if="index == selectedOption" outlined class="rounded-lg shadow-sm overflow-hidden"
              style="min-height: 600px; display: flex; flex-direction: column;">

              <!-- Content Header -->
              <div class="pa-4 grey lighten-5 border-bottom d-flex align-center">
                <v-avatar color="primary" size="40" class="mr-4">
                  <span class="white--text text-h6">{{ dep.id.charAt(0).toUpperCase() }}</span>
                </v-avatar>
                <div>
                  <div class="text-h6 font-weight-bold">{{ dep.id }}</div>
                  <div class="text-caption grey--text">Ajustes generales y de menú online</div>
                </div>
              </div>

              <v-tabs v-model="tab" background-color="transparent" color="primary" grow class="px-4">
                <v-tab class="text-none font-weight-bold">
                  <v-icon left small>mdi-cash-register</v-icon>
                  Punto de Venta
                </v-tab>
                <v-tab class="text-none font-weight-bold">
                  <v-icon left small>mdi-web</v-icon>
                  Menú Online
                </v-tab>
              </v-tabs>
              <v-divider></v-divider>

              <v-card-text class="pa-0 flex-grow-1 overflow-y-auto" style="max-height: 60vh;">
                <v-tabs-items v-model="tab">
                  <!-- Tab: PDV -->
                  <v-tab-item>
                    <div class="pa-6">
                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-tune</v-icon>
                          Ajustes de Venta
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.Caja.Iva" label="IVA (%)" outlined dense
                              prepend-inner-icon="mdi-percent"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" class="py-0">
                            <v-switch v-model="dep.Caja.ForzarNumeroEmpleado" label="Requerir clave administrador"
                              color="primary" dense></v-switch>
                          </v-col>
                          <v-col cols="12" md="6" class="py-0">
                            <v-switch v-model="dep.Tickets.showPropinasSugerida" label="Mostrar sugerencia de propina"
                              color="primary" dense></v-switch>
                          </v-col>
                          <v-col cols="12" md="6" class="py-0">
                            <v-switch v-model="dep.Caja.ForzarClienteVenta" label="Requerir cliente al cerrar la venta"
                              color="primary" dense></v-switch>
                          </v-col>
                          <v-col cols="12" md="6" class="py-0">
                            <v-switch v-model="dep.Caja.RequerirComensales"
                              label="Requerir comensales al cerrar la cuenta" color="primary" dense></v-switch>
                          </v-col>
                          <v-col cols="12" md="6" class="py-0">
                            <v-switch v-model="dep.Caja.ImprimePaseSalida" label="Imprimir pases de salida"
                              color="primary" dense></v-switch>
                          </v-col>
                        </v-row>
                      </div>

                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-ticket-outline</v-icon>
                          Personalización de Ticket
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea label="Título del Ticket" v-model="dep.Tickets.TitleTicket" outlined dense
                              rows="2"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea label="Dirección en Ticket" v-model="dep.Tickets.DirTicket" outlined dense
                              rows="2"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea label="Pie de página (Footer)" v-model="dep.Tickets.TextoTicket" outlined dense
                              rows="3"></v-textarea>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-tab-item>

                  <!-- Tab: Menu Online -->
                  <v-tab-item>
                    <div class="pa-6">
                      <!-- Status and Times -->
                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-clock-outline</v-icon>
                          Estado y Horarios
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row align="center">
                          <v-col cols="12" md="3">
                            <v-switch v-model="dep.MenuOnline.Active" label="Servicio Activo" color="success" dense
                              inset class="mt-0"></v-switch>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu v-model="menuApertura" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="formatTimeDisplay(dep.MenuOnline.Apertura)" label="Hora de Apertura"
                                  prepend-inner-icon="mdi-clock-start" readonly outlined dense v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-time-picker v-if="menuApertura" v-model="dep.MenuOnline.Apertura" format="ampm"
                                :minute-increment="10" full-width>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menuApertura = false">Aceptar</v-btn>
                              </v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu v-model="menuCierre" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="formatTimeDisplay(dep.MenuOnline.Cierre)" label="Hora de Cierre"
                                  prepend-inner-icon="mdi-clock-end" readonly outlined dense v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-time-picker v-if="menuCierre" v-model="dep.MenuOnline.Cierre" format="ampm"
                                :minute-increment="10" full-width>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menuCierre = false">Aceptar</v-btn>
                              </v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-autocomplete label="Zona Horaria" v-model="dep.MenuOnline.TimeZone" :items="timezones"
                              item-value="value" item-text="label" outlined dense
                              prepend-inner-icon="mdi-map-marker-outline"></v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Colors -->
                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-palette-outline</v-icon>
                          Identidad Visual
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                          <v-col cols="12" md="6">
                            <div class="d-flex align-center mb-2">
                              <div
                                :style="`width: 20px; height: 20px; border-radius: 4px; background: ${dep.MenuOnline.Colors.Primary}; margin-right: 8px; border: 1px solid #ddd;`">
                              </div>
                              <span class="text-body-2 font-weight-medium">Color Primario</span>
                            </div>
                            <v-color-picker v-model="dep.MenuOnline.Colors.Primary" dot-size="25" hide-canvas
                              mode="hexa" swatches-max-height="150" width="100%"></v-color-picker>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="d-flex align-center mb-2">
                              <div
                                :style="`width: 20px; height: 20px; border-radius: 4px; background: ${dep.MenuOnline.Colors.Accent}; margin-right: 8px; border: 1px solid #ddd;`">
                              </div>
                              <span class="text-body-2 font-weight-medium">Color Secundario</span>
                            </div>
                            <v-color-picker v-model="dep.MenuOnline.Colors.Accent" dot-size="25" hide-canvas mode="hexa"
                              swatches-max-height="150" width="100%"></v-color-picker>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Contact and Details -->
                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-information-outline</v-icon>
                          Contacto y Detalles
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.NumeroWhatsapp" label="Número WhatsApp" outlined dense
                              prepend-inner-icon="mdi-whatsapp"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.CostoEmpaque" label="Costo Empaque (extras)" outlined
                              dense prepend-inner-icon="mdi-package-variant-closed"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea label="Dirección de Envío" v-model="dep.MenuOnline.Direccion" outlined dense
                              rows="2" prepend-inner-icon="mdi-map-marker"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field v-model="dep.MenuOnline.HomeUrl" label="URL de Web Principal" outlined dense
                              prepend-inner-icon="mdi-link-variant" placeholder="https://ejemplo.com"></v-text-field>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Payment Data -->
                      <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold primary--text mb-2 d-flex align-center">
                          <v-icon small color="primary" class="mr-2">mdi-bank-outline</v-icon>
                          Datos para Transferencias
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.Transferencias.Banco" label="Banco" outlined
                              dense></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.Transferencias.Beneficiario" label="Beneficiario"
                              outlined dense></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.Transferencias.Clabe" label="CLABE" outlined
                              dense></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field v-model="dep.MenuOnline.Transferencias.Tarjeta" label="Tarjeta" outlined
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>

              <!-- Sticky Footer -->
              <div class="actions-footer px-6 py-4 d-flex justify-end mt-auto">
                <v-btn color="primary" elevation="2" large class="text-none px-8 font-weight-bold" rounded
                  @click="saveConfig(dep)">
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar Cambios
                </v-btn>
              </div>

            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>

    <Modal v-model="showModal" :showFooter="false" title="Crear Departamento">
      <div class="pa-4 text-center">
        <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-hammer-wrench</v-icon>
        <div class="text-h6 grey--text">Proximamente</div>
        <p class="grey--text text--lighten-1">Esta funcionalidad estará disponible pronto.</p>
      </div>
    </Modal>
  </div>
</template>


<style scoped>
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.rounded-md {
  border-radius: 6px !important;
}

/* Custom list item hover and active states */
.v-list-item:hover:not(.v-list-item--active) {
  background-color: rgba(0, 0, 0, 0.03);
}

/* Better scrollbar for the settings panel */
.overflow-y-auto {
  scrollbar-width: thin;
  scrollbar-color: #ddd transparent;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 10px;
}

/* Ensure the sticky footer is prominent */
.actions-footer {
  background: white;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.03) !important;
}
</style>


<script>
//import ApiBioTime from "../../clases/ApiBioTime.js";
import { listTz, clientTz } from 'timezone-select-js';
import moment from 'moment';

export default {
  name: "configApp",
  components: {},
  data() {
    return {
      tab: 0,
      //selected: clientTz(),
      timezones: listTz(),
      showModal: false,
      selectedOption: 0,
      dataDep: [],
      dataSDK: [],
      dataAreas: [],
      menuApertura: false,
      menuCierre: false,
    };
  },
  computed: {},
  methods: {
    selectOption(index) {
      this.selectedOption = index;
      this.menuApertura = false;
      this.menuCierre = false;
    },
    async selectDKS(dep, index) {
      let sdk = this.$pgsHelper.getById(this.dataSDK, 'id', dep.CheckIn.Tipo);
      this.dataDep[index].catalogoAreas = await this.getAreas(dep.CheckIn.Tipo);
    },
    formatTimeDisplay(val) {
      if (!val || val === "Invalid date") return "";
      const m = moment(val, [
        "HH:mm",
        "HH:mm:ss",
        "h:mm A",
        "hh:mm A",
        "h:mm a",
        "hh:mm a",
        moment.ISO_8601,
      ]);
      return m.isValid() ? m.format("h:mm A") : "";
    },
    normalizeTime(val) {
      if (!val || val === "Invalid date") return "";
      const m = moment(val, [
        "HH:mm",
        "HH:mm:ss",
        "h:mm A",
        "hh:mm A",
        "h:mm a",
        "hh:mm a",
        moment.ISO_8601,
      ]);
      return m.isValid() ? m.format("HH:mm") : "";
    },
    async setData() {
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/CONF");
      let resultConf = conf.val();
      let arrayObj = this.$pgsHelper.ArrayObjectToArray(resultConf);
      arrayObj.forEach((dep) => {
        dep.catalogoAreas = [];
        if (!dep.MenuOnline) {
          dep.MenuOnline = {
            Active: false,
            Apertura: "00:00",
            Cierre: "23:50",
            TimeZone: clientTz() || "America/Cancun",
            NumeroWhatsapp: "",
            HomeUrl: "",
            Colors: {
              Primary: "#000000",
              Accent: "#7cb342"
            },
            CostoEmpaque: 0,
            Transferencias: {
              Clabe: "",
              Tarjeta: "",
              Banco: "",
              Beneficiario: ""
            }
          }
        } else {
          dep.MenuOnline.Apertura = this.normalizeTime(dep.MenuOnline.Apertura);
          dep.MenuOnline.Cierre = this.normalizeTime(dep.MenuOnline.Cierre);
          if (Array.isArray(dep.MenuOnline.TimeZone)) {
            dep.MenuOnline.TimeZone = clientTz() || "America/Cancun";
          }
        }
        dep.CheckActivo = dep?.CheckIn?.Activo
      })
      this.dataDep = arrayObj;
    },
    async getTiposSdk() {
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("BIO/Activos");
      let resultConf = conf.val();
      this.dataSDK = this.$pgsHelper.ArrayObjectToArray(resultConf);
    },
    async getAreas(sdkTipo) {
      /*let api  = await ApiBioTime.getInstance(sdkTipo);
      let devices = await api.get("/Areas");
      return devices.data;*/
    },
    async loadCatalogos() {
      this.dataDep.forEach(async (dep) => {
        if (dep?.CheckIn?.Tipo) {
          dep.catalogoAreas = await this.getAreas(dep.CheckIn.Tipo);
        }
      })
    },
    saveConfig(dep) {
      let datos = this.$pgsHelper.cloneObj(dep);
      datos.Caja.Iva = Number(datos.Caja.Iva)
      if (!dep.CheckIn) {
        dep.CheckIn = { Activo: true };
      }
      dep.MenuOnline.CostoEmpaque = Number(dep.MenuOnline.CostoEmpaque);
      dep.MenuOnline.Apertura = this.normalizeTime(dep.MenuOnline.Apertura);
      dep.MenuOnline.Cierre = this.normalizeTime(dep.MenuOnline.Cierre);
      dep.CheckIn.Activo = dep.CheckActivo;
      datos.Departamento = datos.id;
      datos.MenuOnline.Apertura = this.normalizeTime(datos.MenuOnline.Apertura);
      datos.MenuOnline.Cierre = this.normalizeTime(datos.MenuOnline.Cierre);
      delete datos.id;
      this.$swal({
        title: "¿Deseas modificar la configuración del sistema?",
        text: " Los cambios se aplicaran en todo el sistema ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Configuracion-editarConfiguracion", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.setData();
            this.$swal({
              title: "Guardado",
              text: "La configuración se guardo correctamente ",
              icon: "success",
            });
          } else {
            this.$swal(
              "Error Aplicando Configuración",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    await this.setData();
    //await this.getTiposSdk();
    await this.loadCatalogos();
  },
};
</script>